import React, { useState, memo, useEffect } from 'react';
import { Image } from 'src/types';
import { chunk } from 'lodash-es';
import { FiX } from 'react-icons/fi';
import ImageWithFallback from 'src/components/ImageWithFallback';
import Loading from 'src/components/Loading';
import classNames from 'classnames';
import styles from 'src/styles/modules/components/grid_photo_popup.module.scss';
import VideoCard from 'src/components/VideoCard';
import Player from '@vimeo/player';

const NUMBER_COLUMN = '2'

type Props = {
  show: boolean;
  optionMedia: Image[];
  onClose: () => void;
  onClickImage?: (image: Image) => void;
};

const changeHeight = (col: number, index: number) => {
  if (index === 0) {
    return false;
  } else {
    if (col % 2 === 0 && index % 3 === 0) {
      return true;
    } else if (col % 2 !== 0 && (index % 2 === 0 || index === 1)) {
      return true;
    }
  }
};

const GridPhotoPopup: React.FC<Props> = ({ show, optionMedia, onClose, onClickImage }) => {
  const mediaSize = optionMedia.length;
  const leftSize = (mediaSize / parseFloat(NUMBER_COLUMN)).toFixed();
  const gridOptionMedia = chunk(optionMedia, Number(leftSize));
  const [players, setPlayers] = useState<Player[]>([]);

  useEffect(()=>{
    if (show) {
      players.map((player, index) => {
        if (index === 0) {
          player.play();
        } else {
          player.pause();
        }
      });
    } else {
      players.map((player) => player.pause());
    }
  }, [show])

  return (
    <>
      <div
        className={classNames(
          'tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-brand-yellow tw-z-101',
          {
            'tw-hidden': !show,
          }
        )}
      >
        <div className="tw-flex tw-py-5 md:tw-px-8 tw-px-4 tw-justify-end">
          <FiX
            size={24}
            strokeWidth={2}
            className="tw-text-brand-navy tw-cursor-pointer"
            onClick={() => {
              if (typeof onClose === 'function') {
                onClose();
              }
            }}
          />
        </div>
        <div
          className={`tw-flex tw-overflow-y-auto tw-overflow-x-hidden tw-justify-center tw-w-full ${styles.photosContainer}`}
        >
          {optionMedia.length > 0 && gridOptionMedia.length > 0 ? (
            <>
              {gridOptionMedia.map((items, col) => (
                <div
                  key={col}
                  className={classNames('md:tw-w-96 tw-w-1/2 tw-px-0.5 md:tw-px-1')}
                >
                  {items.map((media, index) => (
                    <div
                      key={media.id}
                      className={classNames('tw-mb-1 md:tw-mb-2 tw-relative', {
                        [styles.lgMediaHeight]:
                          changeHeight(col, index) || typeof media === 'string',
                        [styles.baseMediaHeight]: !changeHeight(col, index),
                      })}
                    >
                      {typeof media === 'string' ? (
                        <div className="option-video tw-h-full tw-relative tw-rounded-lg tw-border-2 tw-border-brand-green">
                          <VideoCard
                            vimeoId={media}
                            setPlayers={setPlayers}
                            vimeoConfig={{ autoplay: 1 }}
                          />
                        </div>
                      ) : (
                        <ImageWithFallback
                          record={media}
                          imgField="webpLgUrl"
                          alt="Seek Sophie option picture"
                          fill
                          className="tw-object-cover tw-static tw-cursor-pointer tw-w-full tw-h-full tw-rounded-lg tw-border-2 tw-border-brand-green tw-border-solid"
                          onClick={() => {
                            if (typeof onClickImage === 'function') {
                              players.map((player) => player.pause());
                              onClickImage(media);
                            }
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </>
          ) : (
            <Loading className="tw-justify-center" />
          )}
        </div>
      </div>
    </>
  );
};

export default memo(GridPhotoPopup);
